if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        // Reset all native active states
        this.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('active');
        });
        
        // Find the first available image inside the modal to use as our "zoom canvas"
        const firstModalMedia = this.querySelector('[data-media-id]');
        if (!firstModalMedia) return;
        
        firstModalMedia.classList.remove('product__media-item--variant');
        firstModalMedia.classList.add('active');
        firstModalMedia.style.display = 'block';

        // Extract the exact <img> the user clicked natively on the gallery
        if (this.openedBy) {
            const galleryItem = this.openedBy.closest('.product__media-item, .combo-overlay');
            if (galleryItem) {
                const galleryImg = galleryItem.tagName === 'IMG' ? galleryItem : galleryItem.querySelector('img');
                const modalImg = firstModalMedia.tagName === 'IMG' ? firstModalMedia : firstModalMedia.querySelector('img');
                
                if (galleryImg && modalImg && galleryImg.src) {
                    // Spoof the modal's primary image to match exactly what is shown on the page!
                    modalImg.src = galleryImg.src;
                    modalImg.srcset = galleryImg.srcset || galleryImg.src;
                }
            }
        }

        // Just directly reset the scroll since we are using only one active spoofed element
        const container = this.querySelector('[role="document"]');
        if (container) {
          container.scrollTop = 0;
          container.scrollLeft = 0;
        }
      }
    }
  );
}
